<template>
  <EnrollmentHeader />
  <RouterView />
</template>

<script setup lang="ts">
import EnrollmentHeader from "@/layouts/enrollment-new/components/EnrollmentHeader.vue"
</script>
